package pwgs.ui.scenes.generalsettingsscene

import kotlinx.serialization.Serializable
import visage.rmi.VisageController

@VisageController(GeneralSettingsSceneProps::class, GeneralSettingsSceneModel::class)
interface GeneralSettings {
    fun load()
}

@Serializable
class GeneralSettingsSceneProps(val projectId: Long)

@Serializable
class GeneralSettingsSceneModel(
    val clientApiKey: String,
    val serverApiKey: String
) {
    var isLoading = true
}